// extracted by mini-css-extract-plugin
export default {"form-content":"style_form-content__H2XMB","form-row":"style_form-row__Pw+So"};